export default __webpack_public_path__ + "static/media/map.25eb3012.png";